import { type SimpleEntity, type Member } from '@/types';
import { makeActionCreator, makeRequestActionCreator } from '@/utils';
import {
  type FetchMembersPayload,
  type CreateMemberPayload,
  type InviteMemberPayload,
  type AcceptInvitePayload,
  type DeleteMemberPayload,
  type UpdateMemberPayload,
} from './types';
import { membersSlice } from './slice';

const createAction = makeActionCreator(membersSlice.name);
const createRequestAction = makeRequestActionCreator(membersSlice.name);

export const tryFetchMembers =
  createAction<FetchMembersPayload>('tryFetchMembers');

export const fetchMembers = createRequestAction<FetchMembersPayload, Member[]>(
  'fetchMembers',
);

export const tryFetchRoleOptions = createAction('tryFetchRoleOptions');

export const fetchRoleOptions = createRequestAction<void, SimpleEntity[]>(
  'fetchRoleOptions',
);

export const createMember =
  createRequestAction<CreateMemberPayload>('createMember');

export const inviteMember =
  createRequestAction<InviteMemberPayload>('inviteMember');

export const acceptInvite =
  createRequestAction<AcceptInvitePayload>('acceptInvite');

export const deleteMember =
  createRequestAction<DeleteMemberPayload>('deleteMember');

export const updateMember =
  createRequestAction<UpdateMemberPayload>('updateMember');

export const { setMembers, setRoleOptions } = membersSlice.actions;
